import React, { useState } from "react";

import { IconEdit } from "@frontend/common";

import { separateTextAndTranslateCode } from "@/components/shared/utils/separateTextAndTranslatedCode/separateTextAndTranslatedCode";

import EditPressDateInput from "./components/EditPressDateInput/EditPressDateInput";
import PressDuplicateButton from "./components/PressDuplicateButton/PressDuplicateButton";
import TextHoverTooltip from "./components/TextHoverTooltip/TextHoverTooltip";
import * as S from "./TopFixInfoItem.style";

interface Props {
  title: string;
  content: string;
  subContent?: string;
  maxWidth: string;
  minWidth: string;
  width?: string;
  isFlex?: boolean;
  tooltipStyle?: {
    maxWidth?: string;
    minWidth?: string;
    width?: string;
  };
  disableDuplicate?: boolean;
}

const TopFixInfoItem = ({
  title,
  content,
  subContent,
  maxWidth,
  minWidth,
  width,
  isFlex,
  tooltipStyle,
  disableDuplicate = false,
}: Props) => {
  const [targetShell, setTargetShell] = useState("none");
  const [isEditPressDate, setIsEditPressDate] = useState(false);
  const handleCheckTextOverflow = (e: React.MouseEvent) => {
    if (e.currentTarget.clientHeight >= e.currentTarget.scrollHeight) {
      return false;
    }

    return true;
  };

  const handleChangeHoverCompanyShell = (
    e: React.MouseEvent,
    target: string,
  ) => {
    if (!handleCheckTextOverflow(e)) return;
    setTargetShell(target);
  };

  const { text, code } = separateTextAndTranslateCode(content);

  if (title === "Press Date") {
    return (
      <S.TopFixInfoItemWrapper
        $maxWidth={maxWidth}
        $minWidth={minWidth}
        $width={width}
        $isFlex={isFlex}
        className="press-date-item"
      >
        {!isEditPressDate && (
          <S.TransparentBackground
            onClick={(e) => {
              e.stopPropagation();
              setIsEditPressDate(true);
            }}
          />
        )}
        <S.TopFixInfoTitle
          className="press-date-item-title"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {title}
          <IconEdit width={16} height={16} color="#515C6C" />
        </S.TopFixInfoTitle>
        <S.TopFixInfoDateContent
          className="press-date-item-content"
          onMouseOver={(e) => {
            handleChangeHoverCompanyShell(e, title);
          }}
          onMouseLeave={(e) => {
            handleChangeHoverCompanyShell(e, "none");
          }}
        >
          {text || "-"}
          {isEditPressDate ? (
            <EditPressDateInput
              manualPressDate={subContent}
              changeStatus={() => {
                setIsEditPressDate(false);
              }}
            />
          ) : subContent ? (
            <S.ManualPressDateWrapper>
              {`(${subContent})`}
            </S.ManualPressDateWrapper>
          ) : (
            <></>
          )}
        </S.TopFixInfoDateContent>
      </S.TopFixInfoItemWrapper>
    );
  }

  return (
    <S.TopFixInfoItemWrapper
      $maxWidth={maxWidth}
      $minWidth={minWidth}
      $width={width}
      $isFlex={isFlex}
    >
      <S.TopFixInfoTitle>
        {title}
        {!disableDuplicate && <PressDuplicateButton title={title} />}
      </S.TopFixInfoTitle>
      <S.TopFixInfoContent
        onMouseOver={(e) => {
          handleChangeHoverCompanyShell(e, title);
        }}
        onMouseLeave={(e) => {
          handleChangeHoverCompanyShell(e, "none");
        }}
      >
        {title === "Manual Classification" &&
        (text === "Funding Filing" || text === "Deal Filing")
          ? "N/A"
          : text || "-"}

        {code && <S.TranslatedId> {code}</S.TranslatedId>}
      </S.TopFixInfoContent>
      {targetShell === title && (
        <TextHoverTooltip text={content} tooltipStyle={tooltipStyle} />
      )}
    </S.TopFixInfoItemWrapper>
  );
};

export default TopFixInfoItem;
